module.exports = __webpack_public_path__ + "img/stock-img.51759d94.png";